import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check, GraduationCap } from "lucide-react";

/**
 * Carte d'une formation, entièrement cliquable vers sa page : niveau, titre,
 * description, fiche (durée, format, groupe) et premiers modules.
 */
export const CarteFormation = ({ formation, TitreBalise = "h3", detaillee = true }) => {
  const fiche = [
    ["Durée", formation.duration],
    ["Format", formation.format],
    ["Groupe", `${formation.maxParticipants} personnes au plus`],
  ];
  return (
    <Link to={`/formations/${formation.slug}`} className="card">
      <div className="flex items-start justify-between gap-4">
        <GraduationCap
          className="h-9 w-9 flex-none text-accent"
          strokeWidth={1.8}
          aria-hidden="true"
        />
        <span className="tag">{formation.level}</span>
      </div>

      <TitreBalise className="mt-5 text-vt-h3 font-extrabold leading-snug text-brand">
        {formation.title}
      </TitreBalise>
      <p className="mt-3 leading-relaxed text-t2">{formation.description}</p>

      <dl className="mt-6 grid grid-cols-3 gap-3 rounded-[12px] border border-border bg-bg2 p-4">
        {fiche.map(([libelle, valeur]) => (
          <div key={libelle} className="min-w-0">
            <dt className="text-vt-legende font-extrabold uppercase tracking-[0.08em] text-t3">
              {libelle}
            </dt>
            <dd className="mt-1 text-vt-controle font-bold leading-snug text-brand">
              {valeur}
            </dd>
          </div>
        ))}
      </dl>

      {detaillee && (
        <ul className="mt-6 grid gap-2.5">
          {formation.topics.slice(0, 4).map((topic) => (
            <li key={topic} className="flex items-start gap-2.5 font-semibold text-foreground">
              <Check
                className="mt-1 h-4 w-4 flex-none text-accent"
                strokeWidth={2.6}
                aria-hidden="true"
              />
              {topic}
            </li>
          ))}
        </ul>
      )}

      <div className="mt-auto pt-6">
        <span className="btn-outline btn-sm w-full">
          Voir le programme
          <ArrowRight className="h-[1.0625rem] w-[1.0625rem]" strokeWidth={2.4} aria-hidden="true" />
        </span>
      </div>
    </Link>
  );
};
